import { render, staticRenderFns } from "./ExcludeAgenciesIcon.vue?vue&type=template&id=85f9bf60"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports